import type { Component, Entity2D } from '../../odie';
import { PopcornBlockProps } from '../defs/block';
import { PopcornBlockView } from '../views/blocks/PopcornBlockView';

export type PopcornBlockComponentOptions = {
  props: PopcornBlockProps;
};

export class PopcornBlockComponent implements Component {
  public static readonly NAME = 'blockPopcorn';
  public entity!: Entity2D;
  public view!: PopcornBlockView;

  public init(options: PopcornBlockComponentOptions): void {
    this.view = new PopcornBlockView(options.props);
  }
}
